import React from 'react';
import styled from 'styled-components';

export interface AsureCloudRadioButton extends React.InputHTMLAttributes<HTMLInputElement>{
    id: string;
    labelText?: string;
    radioButtonPanel?: boolean;
}

export const AsureCloudRadioButton = ({radioButtonPanel, labelText, ...props}: AsureCloudRadioButton) => {
    const radioButtonClass = radioButtonPanel ? 'radio-button-panel border d-inline-flex p-3 rounded': 'd-flex flex-row flex-nowrap';
    return (
        <RadioContainer>
            <input
                type="radio"
                {...props}
            />
            <label 
                htmlFor={props.id}
                className={`${radioButtonClass} ${props.disabled && 'disabled'} justify-content-center align-items-center mb-0`}
            >
                <span className="radioButtonDisplay mr-1 p-relative d-flex flex-column justify-content-center align-items-center">
                    <svg height="100%" width="100%" viewBox="0 0 100 100">
                        <g>
                            <circle cx="50%" cy="50%" r="45" stroke-width="5"/>
                            <circle cx="50%" cy="50%" r="27" className="checked" />
                        </g>
                    </svg>                
                </span>
                <span className="labelText">{labelText}</span>
            </label>          
        </RadioContainer>
    )
}

export default AsureCloudRadioButton;

const RadioContainer = styled.div`
    input {
        opacity: 0;
        cursor: pointer;
        height: 1px;
        width: 1px;
    }
    .radioButtonDisplay {
        height: 1.25rem;
        width: 1.25rem;

        svg {
            width: 100%;
            height: 100%;
            
            circle { 
                stroke: #BBBBBB; 
                fill: transparent;
            }
            circle.checked {
                fill: transparent;
                stroke: transparent;
            }
        }
    }
    input:checked ~ label .radioButtonDisplay {
        svg {
            circle { stroke: #0082AD;}
            circle.checked {
                fill: #0082AD;
                stroke: #0082AD;
            }
        }
    }
    input:checked:disabled ~ label .radioButtonDisplay {
        svg {
            circle { 
                stroke: #BBBBBB;
                fill: #EEEEEE;
            }
            circle.checked {
                fill: #BBBBBB;
                stroke: #BBBBBB;
            }
        }
    }
    input:disabled ~ label .radioButtonDisplay {
        svg {
            circle { 
                stroke: #BBBBBB;
                fill: #EEEEEE;
            }
            circle.checked {
                stroke: transparent;
            }
        }
    }
    input:focus ~ label .radioButtonDisplay {
        svg {
            circle { stroke: #0082AD;}
            circle.checked {
                stroke: transparent;
            }
        }
    }
    label {
        cursor: pointer;
    }
    input:required ~ label .labelText:after {
        content: '*';
        margin-left: 0.15rem;
        color: #db0020;
        color: var(--color-danger-500);
    }

    input:checked ~ .radio-button-panel {
        border-color: #0082AD !important;
        &.disabled {
            border-color: #BBBBBB !important;
        }
    }
    .radio-button-panel {
        .labelText {
            opacity: 0.6;
        }
        &:focus {
            outline: none;     
        }
        &:hover {
            background-color: #FAFAFA;
        }
        &.disabled {
            background-color: #EEEEEE;
        }  
    }
`;
